// extracted by mini-css-extract-plugin
module.exports = {"results__container":"results_results__container__1hZ5Q","results__img":"results_results__img__3PWIr"};